import { RiseOutlined, RocketOutlined, SoundOutlined, TagOutlined, TeamOutlined } from '@ant-design/icons';
import type { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import type React from 'react';
import type { TaskTourKey } from './OnboardingTourContext';

/**
 * Shared getting-started task list. Consumed by both the Help page's
 * Getting-started section and the first-run Welcome modal so the two
 * surfaces never drift on order, copy, or which task is admin-only.
 *
 * Keys line up 1:1 with `TASK_TOURS` in OnboardingTourContext.ts so
 * clicking a row can trigger `startTaskTour(item.key)` directly.
 */

type AntdIconType = React.ComponentType<Partial<AntdIconProps>>;

export interface GettingStartedItem {
  key: TaskTourKey;
  title: string;
  description: string;
  icon: AntdIconType;
  route: string;
  /** Rows flagged admin-only are filtered out for workspace members. */
  adminOnly?: boolean;
}

export const GETTING_STARTED_ITEMS: GettingStartedItem[] = [
  {
    key: 'explore-catalog',
    title: 'Explore Campaign manager',
    description: 'See every campaign, filter by status, and open the ones that need your attention.',
    icon: RocketOutlined,
    route: '/campaigns',
  },
  {
    key: 'create-upsize',
    title: 'Create an Upsize campaign',
    description: "Temporarily boost your cashback rate. Save as draft, you don't have to submit.",
    icon: RiseOutlined,
    route: '/campaigns',
  },
  {
    key: 'create-ad-sales',
    title: 'Create an Ad Sales campaign',
    description: "Buy featured placements across ShopBack. Save as draft, you don't have to submit.",
    icon: SoundOutlined,
    route: '/campaigns',
  },
  {
    key: 'create-offer',
    title: 'Create a Standalone Offer',
    description: 'Run a shopper-facing deal like % off or free shipping.',
    icon: TagOutlined,
    route: '/campaigns',
  },
  {
    key: 'manage-team',
    title: 'Manage team',
    description: 'Invite teammates and set who has access to which brands.',
    icon: TeamOutlined,
    route: '/admin',
    adminOnly: true,
  },
];
